<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre_"><span class="calibre5"><a></a>Also by Wei Wu Wei</span></p><div class="calibre_1"> </div>
<p class="calibre_2"><span class="calibre5"><em class="italic">F<span class="small">INGERS</span> P<span class="small">OINTING</span> T<span class="small">OWARDS THE</span> M<span class="small">OON</span></em></span></p>
<p class="calibre_2"><span class="calibre5"><em class="italic">A<span class="small">SK THE</span> A<span class="small">WAKENED</span></em></span></p>
<p class="calibre_2"><span class="calibre5"><em class="italic">A<span class="small">LL</span> E<span class="small">LSE</span> I<span class="small">S</span> B<span class="small">ONDAGE</span></em></span></p>
<p class="calibre_2"><span class="calibre5"><em class="italic">O<span class="small">PEN</span> S<span class="small">ECRET</span></em></span></p>
<p class="calibre_2"><span class="calibre5"><em class="italic">T<span class="small">HE</span> T<span class="small">ENTH</span> M<span class="small">AN</span></em></span></p>
<p class="calibre_2"><span class="calibre5"><em class="italic">P<span class="small">OSTHUMOUS</span> P<span class="small">IECES</span></em></span></p>
<p class="calibre_2"><span class="calibre5"><em class="italic">U<span class="small">NWORLDLY</span> W<span class="small">ISE</span></em></span></p> <div class="mbp_pagebreak" id="calibre_pb_2"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_002.vue?ddeaf29e